(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-content-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    for (const button of document.querySelectorAll('[data-scroll-target]')) {
      button.addEventListener('click', () => {
        const target = document.querySelector(button.dataset.scrollTarget);
        target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
